/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T09:30:03.54
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialPayablesItem,
	listFinancialPayablesItemInit,
	listFinancialPayablesItemByAuthorizations,
	deleteFinancialPayablesItem
} from '@api/financial/FinancialPayablesItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialPayablesItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayablesItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPayablesItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayablesItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPayablesItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayablesItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialPayablesItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialPayablesItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
